import React, { Component } from "react";

import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon"

import MDInput from "components/MDInput";
import MDBox from "components/MDBox";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";

import MDTypography from "components/MDTypography";
import styles from "./index.module.css";

import { PATH, UPLOAD_PATH } from "../../constant";
import 'dayjs/locale/it';

import * as ajax from "helpers/ajax";
import dayjs from 'dayjs';
import Calendar from 'react-calendar'
import Tooltip from '@mui/material/Tooltip';
import CalendarIcon from 'components/CalendarIcon'
import { convertDate } from "helpers/functions"


export class GareCalendar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            dateSelected: new Date()
        };
    }

    componentDidMount = () => {
        ajax.ajaxGetStrapi("garas?populate=*", this.loadCallback)
    }

    loadCallback = (response) => {


        let data = [];
        response.data.map((el) => {
            if (!data[el.start_date]) {
                data[el.start_date] = {
                    starting: [],
                    ending: [],
                    sopralluogo:[],
                }
            }
            data[el.start_date].starting.push(el.name)

            if (!data[el.end_date]) {
                data[el.end_date] = {
                    starting: [],
                    ending: [],
                    sopralluogo: [],
                }
            }

            data[el.end_date].ending.push(el.name)

            el.gara_checklists.map((check) => {
                if (check.name == "Sopralluogo") {
                    let date = convertDate(new Date(check.date));
                    if (!data[date]) {
                        data[date] = {
                            starting: [],
                            ending: [],
                            sopralluogo: [],
                        }
                    }
                    data[date].sopralluogo.push(el.name)
                }
            })

        })

        this.setState({ data: data })
    }

    convertDate = (date) => {
        var yyyy = date.getFullYear().toString();
        var mm = (date.getMonth() + 1).toString();
        var dd = date.getDate().toString();

        var mmChars = mm.split('');
        var ddChars = dd.split('');

        return yyyy + '-' + (mmChars[1] ? mm : "0" + mmChars[0]) + '-' + (ddChars[1] ? dd : "0" + ddChars[0]);
    }


    renderDate = (date) => {
        let returnValue = []

        if (this.state.data[date]) {
            if (this.state.data[date].starting.length > 0) {
                this.state.data[date].starting.map((el) => {
                    returnValue.push(<Tooltip key={date + el + "start"} title={"Inizio gara: "+el} ><div className={styles.startingDay} /></Tooltip>)
                })
            }
            if (this.state.data[date].ending.length > 0) {
                this.state.data[date].ending.map((el) => {
                    returnValue.push(<Tooltip key={date + el + "end"} title={"Fine gara: " + el} ><div className={styles.closingDay} /></Tooltip>)
                })
            }
            if (this.state.data[date].sopralluogo.length > 0) {
                this.state.data[date].sopralluogo.map((el) => {
                    returnValue.push(<Tooltip key={date + el + "sopralluogo"} title={"Sopralluogo: " + el} ><div className={styles.startingDay} /></Tooltip>)
                })
            }
        }


        return (
            <div className={styles.dayContainer}>{returnValue}</div>
        );
    }

    render() {

        return (
            <>
                <MDTypography variant={"h5"} textTransform={"uppercase"} mb={2} >Calendario Gare <CalendarIcon onChange={(val) => this.setState({ dateSelected: val })} /></MDTypography>
                <Calendar className={styles.calendar} tileContent={(date) => this.renderDate(this.convertDate(date.date))} onActiveStartDateChange={(val) => this.setState({ dateSelected: val.activeStartDate })} activeStartDate={new Date(this.state.dateSelected)} />
            </>
        )

    }
}

export default GareCalendar;


GareCalendar.defaultProps = {

}
